import Card from '../../components/Card'
import InfoCard from '../../components/InfoCard'

function Info() {
  return (
    <div className='h-full'>
      <Card title='お知らせ' className='rounded-md h-full'>
        <div className='flex flex-col gap-4'>
          <InfoCard type='アップデート' color='blue' title='システムリリースのお知らせ'>
            <span className='text-sm'>
              Tangerine分析コンソールをリリースいたしました。
            </span>
          </InfoCard>
          {/* <InfoCard type='アップデート' color='blue' title='システムアップデートのお知らせ'>
            <span className='text-sm'>
              最新バージョンにアップデートされました。新機能や改善が加わり、より使いやすくなりました。アップデートの詳細についてはこちらをご覧ください。
            </span>
          </InfoCard>
          <InfoCard type='メンテナンス' color='green' title='週次レポートの完了通知'>
            <span className='text-sm'>
              レポートにアクセスして、最新のデータと洞察をご確認ください。レポートへのリンクはこちらです。
            </span>
          </InfoCard>
          <InfoCard type='障害報告' color='red' title='予算超過アラート'>
            <span className='text-sm'>
              あなたのプロジェクトの予算が超過しています。詳細な情報や対処法についてはこちらをご覧ください。早急な対応が必要です。
            </span>
          </InfoCard>
          <InfoCard type='アップデート' color='blue' title='システムアップデートのお知らせ'>
            <span className='text-sm'>
              最新バージョンにアップデートされました。新機能や改善が加わり、より使いやすくなりました。アップデートの詳細についてはこちらをご覧ください。
            </span>
          </InfoCard>
          <InfoCard type='メンテナンス' color='green' title='週次レポートの完了通知'>
            <span className='text-sm'>
              レポートにアクセスして、最新のデータと洞察をご確認ください。レポートへのリンクはこちらです。
            </span>
          </InfoCard> */}
        </div>
      </Card>
    </div>
  )
}

export default Info
